import { Container, FileComponent, Holder, Label } from './styles';
import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';

interface IFileInputProps {
  label: string;
  disabled?: boolean;
  text?: string;
  margin?: number;
  marginContainer?: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLInputElement>): void;
  accept?: string;
  multiple?: boolean;
  children?: React.ReactNode;
  required?: boolean;
}

export interface IFileInputRef {
  clear(): void;
  element: HTMLInputElement;
}

export function isChangeEvent(event: any): event is React.ChangeEvent<HTMLInputElement> {
  return event.type == 'change';
}

export function isDragEvent(event: any): event is React.DragEvent<HTMLInputElement> {
  return event.type == 'drop';
}

export const FileInput = forwardRef<IFileInputRef, IFileInputProps>((props, ref) => {
  const fileElement = useRef<HTMLInputElement>();
  const [inputFileAparece, setInputFileAparece] = useState('');
  const [drag, setDrag] = useState(false);

  // function importar() {
  //   fileElement.current.click();
  // }

  function setFilePath(event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLInputElement>) {
    const files = isChangeEvent(event) ? event.target.files : event.dataTransfer.files;

    if (isDragEvent(event)) {
      event.preventDefault();
      setDrag(false);
    }

    if (!files?.length) return;

    const name = props.multiple ? [...files].map(({ name }) => name).join(', ') : files[0].name;

    setInputFileAparece(name);

    if (props.onChange) {
      props.onChange(event);
    }
  }

  const handleDragEnter = (e) => {
    e.preventDefault();

    setDrag(true);
  };

  const handleDragLeave = () => {
    setDrag(false);
  };

  // useImperativeHandle(
  //   ref,
  //   () => ({
  //     element: fileElement.current,
  //     clear: () => {
  //       fileElement.current.value = '';
  //       setInputFileAparece('');
  //     },
  //   }),
  //   [],
  // );

  return (
    <Container marginContainer={props.marginContainer} disabled={props.disabled}>
      <Holder margin={props.margin}>
        <Label>
          {props.label}
          {props.required ? '*' : ''}
        </Label>
        <FileComponent
          drag={drag}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={(e) => e.preventDefault()}
        >
          <input
            multiple={props.multiple}
            onChange={setFilePath}
            type="file"
            name="arquivo"
            // ref={fileElement}
            disabled={props.disabled}
            accept={props.accept}
          />
          <input
            type="text"
            onDrop={setFilePath}
            name="file"
            placeholder="Arquivo"
            readOnly
            value={props.text || inputFileAparece || ''}
            disabled={props.disabled}
          />
        </FileComponent>
      </Holder>
      <input
        disabled={props.disabled}
        type="button"
        value="Selecionar"
        // onClick={importar}
        className="button"
      />
      {props.children}
    </Container>
  );
});

FileInput.displayName = 'FileInput';

export const ImageInput: React.FC<IFileInputProps> = ({ children, ...props }) => (
  <FileInput accept=".jpg,.jpeg,.png,.svg" {...props}>
    {children}
  </FileInput>
);
